import { api, setConfig } from '../..';
import { mapApiToEntity, mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const passwordLogin = (data: PropertyType, loginType: string): Promise<PropertyType> =>
	api
		.post<PropertyType>(`/login-verification?loginType=${loginType}`, mapEntityToApi(data), setConfig(data))
		.then((res) => {
			return mapApiToEntity(res.data);
		});
